/** Affichage expéditeur RenoviaMail — une seule adresse From visible. */
const EMAIL_RE = /[\w.+-]+@[\w.-]+\.\w+/g;
const BRACKET_EMAIL_RE = /<([^>\s]+@[^>\s]+)>/g;

function firstEmailInText(...parts) {
  const combined = parts.filter(Boolean).join(' ');
  const match = combined.match(EMAIL_RE);
  return match?.[0]?.toLowerCase() || '';
}

/** Une seule ligne expéditeur : nom + première adresse From (sans relay SMTP). */
export function formatFromDisplay(fromName, fromEmail) {
  const rawName = (fromName || '').trim();
  const rawEmail = (fromEmail || '').trim();
  const primary = firstEmailInText(rawName, rawEmail);

  let name = rawName
    .replace(BRACKET_EMAIL_RE, '')
    .replace(EMAIL_RE, '')
    .replace(/\s*(via|par|by)\s*$/i, '')
    .trim();

  if (!name && primary) {
    name = primary.split('@')[0];
  }
  if (!primary) {
    return name || rawEmail || 'Inconnu';
  }
  return `${name} <${primary}>`;
}

export function fromDisplayName(fromName, fromEmail) {
  return formatFromDisplay(fromName, fromEmail).replace(/\s*<[^>]+>\s*$/, '').trim()
    || (fromName || '').trim()
    || (fromEmail || '').trim();
}

export function primaryFromEmail(fromName, fromEmail) {
  return firstEmailInText(fromName, fromEmail) || (fromEmail || '').trim();
}
